import { render, staticRenderFns } from "./EloadSpecialCategory.vue?vue&type=template&id=06b77778&scoped=true"
import script from "./EloadSpecialCategory.vue?vue&type=script&lang=js"
export * from "./EloadSpecialCategory.vue?vue&type=script&lang=js"
import style0 from "./EloadSpecialCategory.vue?vue&type=style&index=0&id=06b77778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b77778",
  null
  
)

export default component.exports